import React, { Suspense, lazy } from 'react'
import PropTypes from 'prop-types'
import { Route as RouterRoute, Switch } from 'react-router-dom'
import PageLoader from 'components/loaders/Page'
import { useAuth } from 'quantic'

import Authentication from 'containers/Authentication'
import PasswordRecovery from 'containers/PasswordRecovery'
import ValidateCertificate from 'containers/ValidateCertificate'
import AccountConfirmation from 'containers/AccountConfirmation'
import NotFound from 'containers/NotFound'

const Home = lazy(() => import('containers/Home'))
const Profile = lazy(() => import('containers/Profile'))
const ClassRoom = lazy(() => import('containers/ClassRoom'))
const CourseView = lazy(() => import('containers/CourseView'))
const CourseByCategory = lazy(() => import('containers/CoursesByCategory'))

const EvaluationIntroduction = lazy(() => import('containers/Evaluation/Introduction'))
const EvaluationQuestions = lazy(() => import('containers/Evaluation/Questions'))

// const CourseByCategory = lazy(() => import('containers/CoursesByCategory'))
const Feed = lazy(() => import('containers/Feed'))
const Help = lazy(() => import('containers/Help'))
const Subscription = lazy(() => import('containers/Subscription'))
const Notifications = lazy(() => import('containers/Notifications'))

function Route({ path, component, exact }) {
  return <RouterRoute exat={Boolean(exact)} path={path} component={component} />
}

function Router() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return (
      <Switch>
        <Route path="/" component={Authentication} exact />
        <Route path="/recuperar-senha" component={PasswordRecovery} />
        <Route path="/validar-certificado" component={ValidateCertificate} />
        <Route path="/validar-conta" exact component={AccountConfirmation} />
        <Route path="/validar-conta/:email" component={AccountConfirmation} />
        <Route path="*" component={NotFound} />
      </Switch>
    )
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/perfil" component={Profile} />
        <Route path="/aula/:id" component={ClassRoom} />
        <Route path="/cursos/:id" component={CourseByCategory} />
        <Route path="/video/:id" component={CourseView} />
        <Route path="/meus-cursos" component={CourseView} />
        <Route path="/avaliacao/sobre/:course/:module" component={EvaluationIntroduction} />
        <Route path="/avaliacao/:course/:module" component={EvaluationQuestions} />
        <Route path="/feed" component={Feed} />
        <Route path="/ajuda" component={Help} />
        <Route path="/subscricao" component={Subscription} />
        <Route path="/notificacoes" component={Notifications} />
        <Route path="*" component={NotFound} />
      </Switch>
    </Suspense>
  )
}

Route.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.node]).isRequired,
  exact: PropTypes.bool,
}

Route.defaultProps = {
  exact: false,
}

export default Router
